export default "__VITE_ASSET__4569d2c0__"